<template lang="pug">
  button.btn-bookmark(:class="css" @click="update" ref="btn" :id="`btn_bookmark_${type}_${data}`")
    i.fa-bookmark(:class="icon")
</template>

<script>
export default {
  name: 'b-bookmark',
  props: {
    data: Number|String,
    type: String,
    solid: Boolean,
    border: Boolean,
    size: String,
    parent_selector: String,
    section_selector: String,
  },
  data() {
    return {
      active: false,
    }
  },
  computed: {
    css() {
      let result = {
        'btn-bookmark-border': this.$props.border,
        'btn-bookmark-small': this.$props.size === 'small',
      }

      result[`btn-bookmark-${this.$props.type}`] = true

      if (!this.$props.solid) result['active'] = this.active

      return result
    },
    icon() {
      if (this.$props.solid) {
        return {'far': !this.active, 'fas': this.active}
      }

      return {'far': true}
    }
  },
  methods: {
    update() {
      let row = {}
      let data = {}
      row[`${this.$props.type}_id`] = this.$props.data
      if (this.active) row['_destroy'] = 1
      data[`${this.$props.type}_bookmarks_attributes`] = [row]

      $.ajax({
        url : '/favoritos',
        data : JSON.stringify({
          user: data,
        }),
        type : 'PATCH',
        contentType : 'application/json',
        success: this.check
      })
    },
    check() {
      $.ajax({
        url : `/favoritos/status?${this.$props.type}_id=${this.$props.data}`,
        type : 'get',
        contentType : 'application/json',
        success: res => {
          this.active = res && res.exists
          if (!this.active && this.$props.parent_selector) {
            $(this.$refs.btn).closest(
                $(this.$refs.btn).closest(this.$props.section_selector).find(this.$props.parent_selector).length == 1 ?
                    this.$props.section_selector : this.$props.parent_selector
            ).fadeOut(400, function(){ $(this).remove() })
          }
        }
      });
    }
  },
  mounted() {
    this.check()
  }
};
</script>



// WEBPACK FOOTER //
// bookmark.vue